var render, staticRenderFns
import script from "./CoeHeader.vue?vue&type=script&lang=js&"
export * from "./CoeHeader.vue?vue&type=script&lang=js&"
import style0 from "./CoeHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/viniazvd/vue-coe-calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d86666')) {
      api.createRecord('11d86666', component.options)
    } else {
      api.reload('11d86666', component.options)
    }
    
  }
}
component.options.__file = "src/components/CoeHeader.vue"
export default component.exports